<div class="offerings-page">
  @if(movementsBlocked) {
  <div class="offerings-alert offerings-alert--error">
    <p-message severity="error" icon="pi pi-ban"
      [text]="'FINANCE.BANNER_MOVEMENTS_BLOCKED' | translate : { count: openPeriodosCount, periods: openPeriodsDisplay }" />
  </div>
  }
  @if(showBanner) {
  <div class="offerings-alert offerings-alert--warn">
    <p-message severity="warn" icon="pi pi-exclamation-triangle"
      [text]="'FINANCE.BANNER_PENDING_REPORT' | translate : { month: previousMonthName }" />
  </div>
  }

  <header class="offerings-hero">
    <div class="offerings-hero__inner">
      <div class="offerings-hero__brand">
        <div class="offerings-hero__icon" aria-hidden="true">
          <i class="pi pi-wallet"></i>
        </div>
        <div class="offerings-hero__text">
          <span class="offerings-hero__eyebrow">{{ 'FINANCE.SUBTITLE' | translate }}</span>
          <h1 class="offerings-hero__title">{{ 'FINANCE.TITLE' | translate }}</h1>
        </div>
      </div>
      <div class="offerings-hero__meta">
        <button type="button" class="offerings-hero__link" (click)="openReportDialog()">
          <i class="pi pi-file-pdf" aria-hidden="true"></i>
          <span>{{ 'FINANCE.TITHE_CERTIFICATE' | translate }}</span>
        </button>
        @if (libros) {
        <p-button [label]="'FINANCE.MONTH_CURRENT' | translate" size="small" icon="pi pi-refresh"
          (click)="mesActual()" styleClass="offerings-hero__btn" />
        }
        <p-button data-tour="offerings-consult" [label]="'FINANCE.CONSULT' | translate" size="small" icon="pi pi-search"
          (click)="openDialogLibros()" styleClass="offerings-hero__btn" />
        <p-button data-tour="offerings-new"
          [attr.data-tour-blocked]="addMovementBlock?.text ?? null"
          [attr.data-tour-blocked-route]="addMovementBlock?.route ?? null"
          [attr.data-tour-blocked-action]="addMovementBlock?.action ?? null"
          [label]="'FINANCE.NEW_MOVEMENT' | translate" size="small" icon="pi pi-plus"
          (click)="openAddModal()" [disabled]="isAddMovementDisabled" styleClass="offerings-hero__btn offerings-hero__btn--cta" />
      </div>
    </div>
  </header>

  @if (monthStripDisplay) {
  <div class="offerings-month-nav" role="region" [attr.aria-label]="'FINANCE.MONTH_STRIP_REGION' | translate" data-tour="offerings-month">
    <p-button type="button" icon="pi pi-chevron-left" [text]="true" [rounded]="true" severity="secondary"
      size="small" class="offerings-month-nav__btn" [disabled]="!puedeIrMesAnterior" (click)="navegarMesRelativo(-1)"
      [pTooltip]="'FINANCE.MONTH_NAV_PREV' | translate" tooltipPosition="top" />
    <div class="offerings-month-nav__label">
      <span class="offerings-month-nav__eyebrow">{{ 'FINANCE.MONTH_STRIP_EYEBROW' | translate }}</span>
      <span class="offerings-month-nav__value notranslate">{{ monthStripDisplay | uppercase }}</span>
    </div>
    <p-button type="button" icon="pi pi-chevron-right" [text]="true" [rounded]="true" severity="secondary"
      size="small" class="offerings-month-nav__btn" [disabled]="!puedeIrMesSiguiente" (click)="navegarMesRelativo(1)"
      [pTooltip]="'FINANCE.MONTH_NAV_NEXT' | translate" tooltipPosition="top" />
  </div>
  }

  <!-- Report Dialog -->
  <p-dialog [header]="'FINANCE.ANNUAL_TITHE_REPORT_TITLE' | translate" [(visible)]="showReportDialog" [modal]="true"
    [style]="{ width: '400px' }" [draggable]="false" [resizable]="false">
    <div class="d-flex flex-column gap-3 py-3">
      <div class="d-flex flex-column gap-2">
        <label class="fw-bold">{{ 'FINANCE.SELECT_YEAR' | translate }}</label>
        <p-select [options]="yearsReport" [(ngModel)]="selectedYearReport" optionLabel="label" optionValue="value"
          [placeholder]="'FINANCE.SELECT_YEAR_PLACEHOLDER' | translate" class="w-100" [style]="{'width':'100%'}"></p-select>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" (click)="showReportDialog = false" [text]="true"></p-button>
        <p-button [label]="'FINANCE.GENERATE_REPORT' | translate" severity="primary" (click)="generateAnnualReport()"
          [loading]="generatingReport" icon="pi pi-file-pdf"></p-button>
      </div>
    </div>
  </p-dialog>

  <div class="offerings-layout">
    <div class="offerings-layout__primary">
      <article class="offerings-panel offerings-panel--balance">
        <header class="offerings-panel__head">
          <div class="offerings-panel__icon offerings-panel__icon--brand">
            <i class="pi pi-chart-line"></i>
          </div>
          <div class="offerings-panel__titles">
            <h2 class="offerings-panel__title">{{ 'FINANCE.BALANCE_PANEL_TITLE' | translate }}</h2>
            <p class="offerings-panel__desc">{{ monthStripDisplay || ('FINANCE.SUBTITLE' | translate) }}</p>
          </div>
        </header>
        <div class="offerings-panel__body">
        <div class="hero-balance-section mb-4">
          <div class="d-flex flex-wrap align-items-center gap-4">
            <div class="saldo-principal flex-shrink-0">
              <span class="hero-label text-secondary mb-2 d-flex align-items-center gap-2">
                <i class="pi pi-calendar"></i>
                <span>{{ 'FINANCE.BALANCE_MONTH' | translate }}</span>
                <button type="button"
                  class="saldo-help-btn"
                  [attr.aria-label]="'FINANCE.BALANCE_HELP_ARIA' | translate"
                  (click)="saldoMesHelp.toggle($event)">
                  <i class="pi pi-question-circle"></i>
                </button>
              </span>
              <p-popover #saldoMesHelp styleClass="saldo-help-popover">
                <p class="saldo-help-legend mb-0">{{ 'FINANCE.BALANCE_MONTH_HINT' | translate }}</p>
              </p-popover>
              <h2 class="hero-amount mb-0">{{saldoDisponibleReal | missionMoney}}</h2>
            </div>

            @if(manejarBancos && cuentasConSaldo.length > 0) {
            <div class="saldo-total-cuentas flex-shrink-0">
              <span class="hero-label text-secondary mb-2 d-flex align-items-center gap-2">
                <i class="pi pi-wallet"></i>
                <span>{{ 'FINANCE.BALANCE_TOTAL' | translate }}</span>
                <button type="button"
                  class="saldo-help-btn"
                  [attr.aria-label]="'FINANCE.BALANCE_HELP_ARIA' | translate"
                  (click)="saldoTotalHelp.toggle($event)">
                  <i class="pi pi-question-circle"></i>
                </button>
              </span>
              <p-popover #saldoTotalHelp styleClass="saldo-help-popover">
                <p class="saldo-help-legend mb-0">{{ 'FINANCE.BALANCE_TOTAL_HINT' | translate }}</p>
              </p-popover>
              <h2 class="hero-amount hero-amount--secondary mb-0">{{ getSaldoTotal() | missionMoney }}</h2>
            </div>

            <div class="cuentas-saldo-row d-flex flex-wrap gap-2 align-items-center">
              @for(item of cuentasConSaldo; track item.nombre) {
              <div class="cuenta-saldo-card">
                <span class="cuenta-saldo-label">
                  <i class="pi me-1"
                    [ngClass]="{'pi-wallet': item.tipo === 'efectivo', 'pi-credit-card': item.tipo !== 'efectivo'}"></i>
                  {{ item.nombre }}
                </span>
                <span class="cuenta-saldo-value">{{ item.saldo | missionMoney }}</span>
              </div>
              }
            </div>
            }
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-6">
            <div class="stat-card success h-100">
              <div class="stat-icon">
                <fa-icon [icon]="['fas', 'cash-register']"></fa-icon>
              </div>
              <div class="stat-info">
                <span class="mini-stat-label">{{ 'FINANCE.BALANCE_PREVIOUS_MONTH' | translate }}</span>
                <span class="mini-stat-value">{{ saldoAnterior | missionMoney }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="stat-card success h-100">
              <div class="stat-icon">
                <fa-icon [icon]="['fas', 'money-bill']"></fa-icon>
              </div>
              <div class="stat-info">
                <span class="mini-stat-label">{{ 'FINANCE.CHURCH_INCOME' | translate }}</span>
                <span class="mini-stat-value">{{ totalEntradasRealesMesActual | missionMoney }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3">
          <div class="col-6">
            <div class="stat-card success h-100">
              <div class="stat-icon">
                <fa-icon [icon]="['fas', 'arrow-trend-up']"></fa-icon>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ 'FINANCE.TOTAL_INCOME' | translate }}</span>
                <span class="stat-value success">{{ totalEntradasMesActual | missionMoney }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="stat-card danger h-100">
              <div class="stat-icon">
                <fa-icon [icon]="['fas', 'arrow-trend-down']"></fa-icon>
              </div>
              <div class="stat-info">
                <span class="stat-label">{{ 'FINANCE.TOTAL_EXPENSES' | translate }}</span>
                <span class="stat-value danger">{{ totalSalidasMesActual | missionMoney }}</span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </article>

      <article class="offerings-panel offerings-panel--summary">
        <header class="offerings-panel__head">
          <div class="offerings-panel__icon offerings-panel__icon--accent">
            <i class="pi pi-list"></i>
          </div>
          <div class="offerings-panel__titles">
            <h2 class="offerings-panel__title">{{ 'FINANCE.SPECIAL_MOVEMENTS_SUMMARY' | translate }}</h2>
          </div>
        </header>
        <div class="offerings-panel__body">
        <div class="financial-cards-grid">
          @for (card of financialCards; track card.label) {
          <div class="financial-card-item">
            <div class="financial-icon-wrapper" [ngClass]="card.color">
              <i [class]="card.icon"></i>
            </div>
            <div class="financial-info">
              <span class="financial-label">{{ card.label }}</span>
              <span class="financial-value">{{ card.value | missionMoney }}</span>
            </div>
          </div>
          } @empty {
          <div class="offerings-empty-state">
            <i class="pi pi-file-o"></i>
            <span>{{ 'FINANCE.NO_SPECIAL_MOVEMENTS' | translate }}</span>
          </div>
          }
        </div>
        </div>
      </article>
    </div>

  @if (rows.length > 0) {
  <article class="offerings-panel offerings-panel--table">
    <header class="offerings-panel__head offerings-panel__head--toolbar">
      <div class="offerings-panel__icon offerings-panel__icon--finance">
        <i class="pi pi-table"></i>
      </div>
      <div class="offerings-panel__titles">
        <h2 class="offerings-panel__title">{{ 'FINANCE.MOVEMENTS_TITLE' | translate }}</h2>
      </div>
      <div class="offerings-toolbar__search" data-tour="offerings-search">
        <p-iconField class="w-100">
          <p-inputicon class="pi pi-search" />
          <input pInputText type="text" (input)="applyGlobalFilter($event)" [placeholder]="'FINANCE.SEARCH_PLACEHOLDER' | translate"
            class="w-100" />
        </p-iconField>
      </div>
    </header>

    <div class="offerings-panel__body offerings-panel__body--flush">
    <div class="offerings-table-toolbar">
      <p-tabs [value]="activeTabIndex" class="offerings-tabs">
        <p-tablist>
          <p-tab [value]="0" (click)="selectTab(0)">{{ 'FINANCE.TAB_ALL' | translate }}</p-tab>
          <p-tab [value]="1" (click)="selectTab(1)">{{ 'FINANCE.TAB_INCOME' | translate }}</p-tab>
          <p-tab [value]="2" (click)="selectTab(2)">{{ 'FINANCE.TAB_EXPENSES' | translate }}</p-tab>
          <p-tab [value]="3" (click)="selectTab(3)">{{ 'FINANCE.TAB_TITHES' | translate }}</p-tab>
          <p-tab [value]="4" (click)="selectTab(4)">{{ 'FINANCE.TAB_OFFERINGS' | translate }}</p-tab>
          <p-tab [value]="5" (click)="selectTab(5)">{{ 'FINANCE.TAB_SPECIAL_OFFERING' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel [value]="0"></p-tabpanel>
          <p-tabpanel [value]="1"></p-tabpanel>
          <p-tabpanel [value]="2"></p-tabpanel>
          <p-tabpanel [value]="3"></p-tabpanel>
          <p-tabpanel [value]="4"></p-tabpanel>
          <p-tabpanel [value]="5"></p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>

    <div class="offerings-table-actions">
      <div class="offerings-table-actions__totals">
        @if(activeTabIndex >= 1 && activeTabIndex <= 5) {
        <div class="offerings-table-total"
          [class.offerings-table-total--income]="activeTabIndex === 1 || activeTabIndex === 3"
          [class.offerings-table-total--expense]="activeTabIndex === 2"
          [class.offerings-table-total--neutral]="activeTabIndex === 4 || activeTabIndex === 5">
          <span class="offerings-table-total__label">{{ 'FINANCE.TOTAL_PREFIX' | translate }}</span>
          <span class="offerings-table-total__value">{{ filterTotal | missionMoney }}</span>
        </div>
        }
      </div>
      <div class="offerings-table-actions__exports" data-tour="offerings-export">
        <p-button [label]="'FINANCE.EXPORT_EXCEL' | translate" icon="pi pi-file-excel" (click)="exportToExcel()"
          size="small" styleClass="offerings-export-btn offerings-export-btn--excel" />
        <p-button [label]="'FINANCE.EXPORT_PDF' | translate" icon="pi pi-file-pdf" (click)="exportToPdf()"
          size="small" styleClass="offerings-export-btn offerings-export-btn--pdf" />
      </div>
    </div>

    <p-table #dt [value]="filteredRows" [paginator]="true" [rows]="50" [showCurrentPageReport]="true"
      [tableStyle]="{ 'min-width': '52rem' }" [rowsPerPageOptions]="[25, 50, 100, 200]"
      styleClass="offerings-movements-table" [stripedRows]="true"
      [currentPageReportTemplate]="'FINANCE.PAGINATION_TEMPLATE' | translate"
      [globalFilterFields]="['concepto', 'nombre', 'descripcion', 'tipoMovimiento']">
      <ng-template pTemplate="header">
        <tr>
          <th class="movements-th movements-th--type">{{ 'FINANCE.COL_TYPE' | translate }}</th>
          <th class="movements-th movements-th--date">{{ 'FINANCE.COL_DATE' | translate }}</th>
          <th class="movements-th movements-th--concept">{{ 'FINANCE.COL_CONCEPT' | translate }}</th>
          @if(manejarBancos) {
          <th class="movements-th movements-th--account">{{ 'FINANCE.COL_ACCOUNT' | translate }}</th>
          }
          <th class="movements-th movements-th--amount">{{ 'FINANCE.COL_AMOUNT' | translate }}</th>
          <th class="movements-th movements-th--actions">{{ 'FINANCE.COL_ACTIONS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="movements-row">
          <td class="movements-cell movements-cell--type">
            <span class="movements-type" [ngClass]="{
                'movements-type--income': rowData.tipoMovimiento === 'Ingreso',
                'movements-type--expense': rowData.tipoMovimiento === 'Egreso',
                'movements-type--transfer': rowData.tipoMovimiento === 'Transferencia'
              }">
              <span class="movements-type__icon" aria-hidden="true">
                <i class="pi" [ngClass]="{
                  'pi-arrow-up': rowData.tipoMovimiento === 'Ingreso',
                  'pi-arrow-down': rowData.tipoMovimiento === 'Egreso',
                  'pi-arrows-h': rowData.tipoMovimiento === 'Transferencia'
                }"></i>
              </span>
              <span class="movements-type__label">{{ getMovementTypeLabelByValue(rowData.tipoMovimiento, rowData.tipoMovimiento) }}</span>
            </span>
          </td>
          <td class="movements-cell movements-cell--date">
            <span class="movements-date">{{ convertTimestampString(rowData.fecha) }}</span>
          </td>
          <td class="movements-cell movements-cell--concept">
            @if(rowData.nombre != "" && rowData.nombre != null && rowData.nombre != undefined) {
              @if(activeTabIndex === 3) {
              <span class="movements-concept__main">{{ rowData.nombre }}</span>
              } @else {
              <span class="movements-concept__main">{{ getConceptLabelByRow(rowData) }}</span>
              <span class="movements-concept__meta">{{ rowData.nombre }}</span>
              }
            } @else if (rowData.autoGenerated === true && (rowData.codigo?.toString() ?? '').trim().toUpperCase() === 'ING-SAL-ANT') {
              <span class="movements-concept__main">{{ 'FINANCE.CLOSE_REPORT_LABEL' | translate }}</span>
              <span class="movements-concept__meta">{{ getConceptLabelByRow(rowData) || '-' }}</span>
            } @else if(rowData.descripcion != "" && rowData.descripcion != null && rowData.descripcion != undefined) {
              <span class="movements-concept__main">{{ getConceptLabelByRow(rowData) }}</span>
              <span class="movements-concept__meta">{{ rowData.descripcion }}</span>
            } @else {
              <span class="movements-concept__main">{{ getConceptLabelByRow(rowData) }}</span>
            }
          </td>
          @if(manejarBancos) {
          <td class="movements-cell movements-cell--account">
            @if(rowData.tipoMovimiento === 'Transferencia') {
            <span class="movements-account movements-account--transfer">
              <span>{{ getCuentaNombre(rowData.cuentaOrigen) }}</span>
              <i class="pi pi-arrow-right" aria-hidden="true"></i>
              <span>{{ getCuentaNombre(rowData.cuentaDestino) }}</span>
            </span>
            } @else if(rowData.tipoMovimiento === 'Ingreso') {
            <span class="movements-account movements-account--income">
              <i class="pi pi-arrow-down" aria-hidden="true"></i>
              <span>{{ getCuentaNombre(rowData.cuentaDestino) }}</span>
            </span>
            } @else if(rowData.tipoMovimiento === 'Egreso') {
            <span class="movements-account movements-account--expense">
              <i class="pi pi-arrow-up" aria-hidden="true"></i>
              <span>{{ getCuentaNombre(rowData.cuentaOrigen) }}</span>
            </span>
            }
          </td>
          }
          <td class="movements-cell movements-cell--amount">
            <span class="movements-amount" [ngClass]="{
              'movements-amount--expense': rowData.tipoMovimiento === 'Egreso',
              'movements-amount--income': rowData.tipoMovimiento === 'Ingreso',
              'movements-amount--transfer': rowData.tipoMovimiento === 'Transferencia'
            }">{{ rowData.monto | missionMoney }}</span>
          </td>
          <td class="movements-cell movements-cell--actions">
            <div class="movements-row-actions">
              <p-button icon="pi pi-pencil" styleClass="movements-action-btn"
                [pTooltip]="'FINANCE.TOOLTIP_EDIT' | translate" tooltipPosition="top"
                (click)="editOffering(rowData)" [disabled]="periodoCerrado" />
              <p-button icon="pi pi-trash" styleClass="movements-action-btn movements-action-btn--danger"
                [pTooltip]="'FINANCE.TOOLTIP_DELETE' | translate" tooltipPosition="top"
                (click)="deleteOffering(rowData)" [disabled]="periodoCerrado" />
              @if(canViewLogs) {
              <p-button icon="pi pi-history" styleClass="movements-action-btn movements-action-btn--muted"
                [pTooltip]="'FINANCE.TOOLTIP_HISTORY' | translate" tooltipPosition="top"
                (click)="openHistorial(rowData)" />
              }
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="manejarBancos ? 6 : 5">
            <div class="movements-table-empty">
              <i class="pi pi-filter-slash" aria-hidden="true"></i>
              <p>{{ 'FINANCE.NO_MOVEMENTS_FILTERED' | translate }}</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
  </article>
  } @else {
  <div class="offerings-empty-panel">
    <i class="pi pi-inbox"></i>
    <p>{{ 'FINANCE.NO_RECORDS_THIS_MONTH' | translate }}</p>
  </div>
  }
  </div>

  <!-- Add/Edit Movement Dialog -->
  <p-dialog [(visible)]="showModal" [modal]="true" [style]="{ width: 'min(600px, 94vw)' }"
    styleClass="movement-dialog" contentStyleClass="movement-dialog__content"
    (onShow)="guardMovementDialogOnShow()" (onHide)="isEditing=false"
    [draggable]="false" [focusOnShow]="false" [dismissableMask]="true" [appendTo]="'body'"
    [baseZIndex]="10000">

    <ng-template pTemplate="header">
      <div class="movement-dialog__header">
        <span class="movement-dialog__header-icon" aria-hidden="true">
          <i class="pi" [ngClass]="isEditing ? 'pi-pencil' : 'pi-plus-circle'"></i>
        </span>
        <div class="movement-dialog__header-text">
          <span class="movement-dialog__header-title">
            {{ (isEditing ? 'FINANCE.DIALOG_EDIT_MOVEMENT' : 'FINANCE.DIALOG_ADD_MOVEMENT') | translate }}
          </span>
          <span class="movement-dialog__header-sub">{{ 'FINANCE.SUBTITLE' | translate }}</span>
        </div>
      </div>
    </ng-template>

    @if(nuevaIglesia) {
    <div class="movement-dialog__notice" role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <span>{{ 'FINANCE.NEW_CHURCH_FIRST_MOVEMENT' | translate }}</span>
    </div>
    }

    <form #offeringForm="ngForm" class="movement-dialog__form p-fluid">

      <section class="movement-dialog__section">
        <header class="movement-dialog__section-head">
          <span class="movement-dialog__section-icon movement-dialog__section-icon--brand">
            <i class="pi pi-calendar-clock"></i>
          </span>
          <h3 class="movement-dialog__section-title">{{ 'FINANCE.SECTION_BASIC_INFO' | translate }}</h3>
        </header>
        <div class="movement-dialog__section-body">
        <div class="row g-3">
          <div class="col-md-6" data-tour="movement-date">
            <p-floatlabel variant="on">
              <p-datePicker class="w-full movement-dialog__datepicker" id="fecha" inputId="fecha"
                [(ngModel)]="newOffering.fecha" name="fecha" iconDisplay="button" [showIcon]="true"
                [appendTo]="'body'" [showButtonBar]="true" dateFormat="dd/mm/yy"
                [minDate]="minMovementDate" [maxDate]="maxMovementDate"></p-datePicker>
              <label for="fecha">{{ 'FINANCE.FIELD_DATE' | translate }}</label>
            </p-floatlabel>
          </div>

          <div class="col-md-6" data-tour="movement-amount">
            <p-floatLabel variant="on">
              @if (showModal) {
                @for (montoInputKey of [currencyCode + '|' + currencyLocale]; track montoInputKey) {
                  <p-inputNumber class="w-full" id="monto" [(ngModel)]="newOffering.monto" name="monto" mode="currency"
                    [currency]="currencyCode" [locale]="currencyLocale" required></p-inputNumber>
                }
              }
              <label for="monto">{{ 'FINANCE.FIELD_AMOUNT' | translate }}</label>
            </p-floatLabel>
          </div>
        </div>
        </div>
      </section>

      <section class="movement-dialog__section">
        <header class="movement-dialog__section-head">
          <span class="movement-dialog__section-icon movement-dialog__section-icon--accent">
            <i class="pi pi-tag"></i>
          </span>
          <h3 class="movement-dialog__section-title">{{ 'FINANCE.SECTION_TYPE_CONCEPT' | translate }}</h3>
        </header>
        <div class="movement-dialog__section-body">
        @if(isEditing && newOffering.codigo === 'ING-01') {
        <div class="row g-3">
          <div class="col-12">
            <p-floatlabel variant="on">
              <input pInputText id="tipoMovimiento" class="w-full"
                [value]="getMovementTypeLabelByValue(newOffering.tipoMovimiento)"
                autocomplete="off" readonly />
              <label for="tipoMovimiento">
                <i class="pi pi-arrow-right-arrow-left me-1"></i>{{ 'FINANCE.FIELD_MOVEMENT_TYPE' | translate }}
              </label>
            </p-floatlabel>
          </div>

          <div class="col-12">
            <p-floatlabel variant="on">
              <input pInputText id="concepto" class="w-full" [value]="newOffering.concepto" autocomplete="off"
                readonly />
              <label for="concepto">
                <i class="pi pi-bookmark me-1"></i>{{ 'FINANCE.FIELD_CONCEPT' | translate }}
              </label>
            </p-floatlabel>
          </div>
        </div>
        } @else {
        <div class="row g-3">
          <div class="col-12" data-tour="movement-type">
            <p-floatLabel variant="on">
              <p-select name="tipoMovimiento" [options]="movimientoOptionsFiltered" optionLabel="label"
                optionValue="value" [(ngModel)]="newOffering.tipoMovimiento" appendTo="body" [showClear]="true"
                class="w-full" [readonly]="nuevaIglesia" />
              <label for="tipoMovimiento">
                <i class="pi pi-arrow-right-arrow-left me-1"></i>{{ 'FINANCE.FIELD_MOVEMENT_TYPE' | translate }}
              </label>
            </p-floatLabel>
          </div>

          @if(newOffering.tipoMovimiento !== 'Transferencia') {
          <div class="col-12" data-tour="movement-concept">
            <p-floatLabel variant="on">
              <p-select name="concepto" [options]="currentTipoOptions" optionLabel="label" optionValue="value"
                [(ngModel)]="newOffering.concepto" [disabled]="!newOffering.tipoMovimiento" appendTo="body"
                [showClear]="true" class="w-full" (ngModelChange)="onConceptoChange($event)"
                [readonly]="nuevaIglesia" />
              <label for="concepto">
                <i class="pi pi-bookmark me-1"></i>{{ 'FINANCE.FIELD_CONCEPT' | translate }}
              </label>
            </p-floatLabel>
          </div>
          } @else {
          <div class="col-12">
            <div class="movement-dialog__hint">
              <i class="pi pi-arrows-h" aria-hidden="true"></i>
              <span>{{ 'FINANCE.TRANSFER_INFO' | translate }}</span>
            </div>
          </div>
          }
        </div>
        }
        </div>
      </section>

      @if(manejarBancos && newOffering.tipoMovimiento && newOffering.tipoMovimiento !== '') {
      <section class="movement-dialog__section">
        <header class="movement-dialog__section-head">
          <span class="movement-dialog__section-icon movement-dialog__section-icon--finance">
            <i class="pi pi-wallet"></i>
          </span>
          <h3 class="movement-dialog__section-title">{{ 'FINANCE.SECTION_ACCOUNTS' | translate }}</h3>
        </header>
        <div class="movement-dialog__section-body">
        <div class="row g-3">
          @if(newOffering.tipoMovimiento === 'Ingreso') {
          <div class="col-12">
            <p-floatLabel variant="on">
              <p-select name="cuentaDestino" [options]="getCuentasActivas()" optionLabel="nombre" optionValue="id"
                [(ngModel)]="newOffering.cuentaDestino" appendTo="body" class="w-full" />
              <label for="cuentaDestino">
                <i class="pi pi-arrow-down me-1"></i>{{ 'FINANCE.FIELD_DEST_ACCOUNT' | translate }}
              </label>
            </p-floatLabel>
          </div>
          }

          @if(newOffering.tipoMovimiento === 'Egreso') {
          <div class="col-12">
            <p-floatLabel variant="on">
              <p-select name="cuentaOrigen" [options]="getCuentasActivas()" optionLabel="nombre" optionValue="id"
                [(ngModel)]="newOffering.cuentaOrigen" appendTo="body" class="w-full" />
              <label for="cuentaOrigen">
                <i class="pi pi-arrow-up me-1"></i>{{ 'FINANCE.FIELD_ORIGIN_ACCOUNT' | translate }}
              </label>
            </p-floatLabel>
          </div>
          }

          @if(newOffering.tipoMovimiento === 'Transferencia') {
          <div class="col-md-6">
            <p-floatLabel variant="on">
              <p-select name="cuentaOrigen" [options]="getCuentasActivas()" optionLabel="nombre" optionValue="id"
                [(ngModel)]="newOffering.cuentaOrigen" appendTo="body" class="w-full" />
              <label for="cuentaOrigen">
                <i class="pi pi-arrow-up me-1"></i>{{ 'FINANCE.FIELD_ORIGIN_ACCOUNT' | translate }}
              </label>
            </p-floatLabel>
          </div>

          <div class="col-md-6">
            <p-floatLabel variant="on">
              <p-select name="cuentaDestino" [options]="getCuentasActivasExceptoOrigen()" optionLabel="nombre"
                optionValue="id" [(ngModel)]="newOffering.cuentaDestino" appendTo="body" class="w-full" />
              <label for="cuentaDestino">
                <i class="pi pi-arrow-down me-1"></i>{{ 'FINANCE.FIELD_DEST_ACCOUNT' | translate }}
              </label>
            </p-floatLabel>
          </div>
          }
        </div>
        </div>
      </section>
      }

      <section class="movement-dialog__section">
        <header class="movement-dialog__section-head">
          <span class="movement-dialog__section-icon movement-dialog__section-icon--soft">
            <i class="pi pi-info-circle"></i>
          </span>
          <h3 class="movement-dialog__section-title">{{ 'FINANCE.SECTION_ADDITIONAL_DETAILS' | translate }}</h3>
        </header>
        <div class="movement-dialog__section-body">
        @if (newOffering.codigo === 'ING-01' && newOffering.tipoMovimiento === 'Ingreso') {
        <div class="row g-3">
          <div class="col-12">
            @if(isEditing && newOffering.codigo === 'ING-01') {
            <p-floatlabel variant="on">
              <input pInputText id="nombre" class="w-full" [value]="newOffering.nombre" autocomplete="off" readonly />
              <label for="nombre">
                <i class="pi pi-user me-1"></i>{{ 'FINANCE.FIELD_NAME' | translate }}
              </label>
            </p-floatlabel>
            } @else {
            <p-floatLabel variant="on">
              <p-autoComplete class="flex-grow-1" inputId="nombre" [optionLabel]="'nombreCompleto'"
                [suggestions]="opcionesMiembro" (completeMethod)="buscarMiembros($event)"
                (onSelect)="seleccionarMiembro($event.value)" [forceSelection]="false" [(ngModel)]="searchNombre"
                (ngModelChange)="onNombreChange($event)" [forceSelection]="false" appendTo="body" name="nombre"
                style="width:100%; display:block;" styleClass="w-full" [inputStyle]="{'width': '100%'}">
                <ng-template let-member pTemplate="item" class="w-full">
                  {{ member.nombres }} {{ member.apellidos }}
                </ng-template>
                <ng-template let-member pTemplate="selectedItem" class="w-full">
                  {{ member.nombreCompleto }}
                </ng-template>
              </p-autoComplete>
              <label for="nombre">
                <i class="pi pi-user me-1"></i>{{ 'FINANCE.FIELD_MEMBER_NAME' | translate }}
              </label>
            </p-floatLabel>
            }
          </div>
        </div>
        } @else {
        <div class="row g-3">
          <div class="col-12">
            <p-floatLabel variant="on">
              <input type="text" pInputText name="descripcion" [(ngModel)]="newOffering.descripcion" class="w-full" />
              <label for="descripcion">
                <i class="pi pi-align-left me-1"></i>{{ 'FINANCE.FIELD_DESCRIPTION_OPTIONAL' | translate }}
              </label>
            </p-floatLabel>
          </div>
        </div>
        }
        </div>
      </section>

    </form>

    <ng-template pTemplate="footer">
      <div class="movement-dialog__footer" data-tour="movement-save">
        <p-button [label]="'COMMON.CANCEL' | translate" icon="pi pi-times" severity="secondary"
          styleClass="movement-dialog__btn-cancel" (click)="showModal=false" />
        <p-button [label]="isEditing ? ('COMMON.UPDATE' | translate) : ('COMMON.SAVE' | translate)"
          [icon]="isEditing ? 'pi pi-check' : 'pi pi-save'" styleClass="movement-dialog__btn-save"
          (click)="saveMovimiento()"
          [disabled]="offeringForm.invalid || !newOffering.monto || newOffering.monto <= 0 || (newOffering.tipoMovimiento !== 'Transferencia' && !newOffering.concepto)" />
      </div>
    </ng-template>
  </p-dialog>

  <p-confirmdialog>
    <ng-template #message let-message>
      <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
        <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmdialog>

  <p-toast></p-toast>

  <p-dialog [(visible)]="monthDialog" [header]="'FINANCE.MONTH_DIALOG_TITLE' | translate" [modal]="true" [draggable]="false"
    [dismissableMask]="true" [style]="{ width: '420px' }" [focusOnShow]="false" [appendTo]="'body'"
    [baseZIndex]="10000">
    <div class="row">
      <div class="col-12">
        <p-floatlabel>
          <p-datepicker inputId="monthPicker" [(ngModel)]="selectedMonth" view="month" dateFormat="mm/yy"
            [readonlyInput]="true" showIcon iconDisplay="input" [appendTo]="'body'"
            [maxDate]="maxMonthConsultDate" />
          <label for="monthPicker">{{ 'FINANCE.MONTH_YEAR' | translate }}</label>
        </p-floatlabel>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button [label]="'COMMON.CANCEL' | translate" severity="secondary" (onClick)="monthDialog = false"
        styleClass="p-button-text"></p-button>

      <p-button [label]="'FINANCE.CONSULT' | translate" icon="pi pi-search" [disabled]="!selectedMonth" (onClick)="consultarMovimientos()"
        styleClass="p-button-text"></p-button>
    </ng-template>
  </p-dialog>

  <!-- Historial de cambios del movimiento (solo Pastor / Admin) -->
  <p-dialog [(visible)]="historialDialogVisible" [modal]="true" [draggable]="false" [dismissableMask]="true"
    [style]="{ width: '560px' }" [focusOnShow]="false" styleClass="historial-dialog" (onHide)="closeHistorial()"
    [appendTo]="'body'" [baseZIndex]="10000">
    <ng-template pTemplate="header">
      <div class="historial-header">
        <span class="historial-header-icon"><i class="pi pi-history"></i></span>
        <div class="historial-header-text">
          <span class="historial-header-title">{{ 'FINANCE.HISTORY_DIALOG_TITLE' | translate }}</span>
          @if(getHistorialMovimientoTitulo()) {
          <span class="historial-header-subtitle">{{ getHistorialMovimientoTitulo() }}</span>
          }
        </div>
      </div>
    </ng-template>

    @if(historialMovimiento) {
    <div class="historial-meta">
      <div class="historial-meta-item">
        <span class="historial-meta-label">{{ 'FINANCE.HISTORY_CREATED_BY' | translate }}</span>
        <span class="historial-meta-value">{{ historialMovimiento.createdByName || '—' }}</span>
      </div>
      <div class="historial-meta-item">
        <span class="historial-meta-label">{{ 'FINANCE.HISTORY_UPDATED_BY' | translate }}</span>
        <span class="historial-meta-value">{{ historialMovimiento.updatedByName || historialMovimiento.createdByName || '—' }}</span>
      </div>
    </div>
    }

    @if(historialEntries.length > 0) {
    <ul class="historial-timeline">
      @for(entry of visibleHistorialEntries; track $index) {
      <li class="historial-item" [ngClass]="entry.action === 'create' ? 'is-create' : 'is-update'">
        <span class="historial-dot">
          <i class="pi" [ngClass]="entry.action === 'create' ? 'pi-plus' : 'pi-pencil'"></i>
        </span>
        <div class="historial-content">
          <div class="historial-content-top">
            <span class="historial-action">
              {{ (entry.action === 'create' ? 'FINANCE.HISTORY_ACTION_CREATE' : 'FINANCE.HISTORY_ACTION_UPDATE') | translate }}
            </span>
            <span class="historial-date">{{ entry.fecha }}</span>
          </div>
          <div class="historial-author">
            <i class="pi pi-user"></i> {{ entry.byName }}
          </div>
          @if(entry.resumen) {
          <div class="historial-resumen">{{ entry.resumen }}</div>
          } @else if(entry.campos?.length) {
          <div class="historial-campos">
            @for(campo of entry.campos; track campo) {
            <span class="historial-chip">{{ campo }}</span>
            }
          </div>
          }
        </div>
      </li>
      }
    </ul>
    @if (hasMoreHistorialEntries) {
    <div class="historial-load-more">
      <span class="historial-showing text-muted small">
        {{ 'COMMON.HISTORY_SHOWING' | translate:{ visible: historialVisibleCount, total: historialEntries.length } }}
      </span>
      <p-button [label]="'COMMON.HISTORY_LOAD_MORE' | translate" icon="pi pi-chevron-down"
        severity="secondary" styleClass="p-button-text p-button-sm" (onClick)="loadMoreHistorial()"></p-button>
    </div>
    }
    } @else {
    <div class="historial-empty">
      <i class="pi pi-inbox"></i>
      <span>{{ 'FINANCE.HISTORY_EMPTY' | translate }}</span>
    </div>
    }

    <ng-template pTemplate="footer">
      <p-button [label]="'COMMON.CLOSE' | translate" icon="pi pi-times" severity="secondary"
        styleClass="p-button-text" (onClick)="closeHistorial()"></p-button>
    </ng-template>
  </p-dialog>

</div>